/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-11-01 16:47:26
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-11-04 14:44:27
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/OrderDetail/PickAndPack/Components/PackageDetail/TakePhoto/index.tsx
 */
import React from 'react';
import css from './css.module.less';
// import Webcam from 'react-webcam';
// import { modal } from '@/src/utils/Modal';
import { cameraPhotoUploaded } from 'src/request/common';
import { dataURI2Blob } from 'src/tools/helper';
import { msg } from '@/src/tools/message';
import { Spin } from 'antd';
import Camera from 'src/components/Webcam';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const videoConstraints = {
  width: { min: 900 },
  height: { min: 500 },
  aspectRatio: 1.8,
  facingMode: 'environment',
};
const TakePhoto = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { onSave, onCancel } = props;
  const webcamRef = React.useRef(null);
  const [spin, setSpin] = React.useState(false);

  const capture = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      const blob = dataURI2Blob(imageSrc);

      const formData = new FormData();
      setSpin(true);
      formData.append('file', blob, `拍照=_=${Date.now()}`);
      cameraPhotoUploaded(formData)
        .then((res) => {
          msg.success(
            getI18n(
              `allOrders.orderDetail.components_packagedetail_takePhoto_capture_cameraPhotoUploaded_msgsuccess`,
            ),
          );
          //console.log('res', res);
          onSave(res);
          setSpin(false);
        })
        .catch(() => {
          setSpin(false);
        });
    }
    // serves({
    //   method: 'post',
    //   url: 'https://dev-server-v2.unifyxp.com/portal/mediaLibrary/upload?type=parcel',
    //   data: formData,
    //   headers: {
    //     'Content-Type': 'multipart/form-data',
    //   },
    // });

    //console.log('imageSrc');
  };

  return (
    <Spin spinning={spin}>
      <div className={css.container}>
        <div className={css.webCameraContainer}>
          <Camera
            videoConstraints={videoConstraints}
            width={900}
            screenshotFormat='image/jpeg'
            height={500}
            cameraRef={webcamRef}
            onError={onCancel}
          />
        </div>
        <div className={css.btnContainer}>
          <div className={css.cancel} onClick={onCancel}>
            {getI18n('general.cancel')}
          </div>
          <div className={css.take} onClick={capture}>
            Take Photo
          </div>
          {/* <div className={css.btnContainer}></div> */}
        </div>
      </div>
    </Spin>
  );
};
export default TakePhoto;
